import React from 'react';
import { useFormContext } from 'react-hook-form';

import KogInputTextControlledNew from '@/main/components/shared/inputText/inputTextControlledNew';
import { GeneralVariableType, useDynamicFiltersExport } from './dynamicFiltersExport';

interface IVariableTypeFreeDecimalProps extends GeneralVariableType { }
function VariableTypeFreeDecimal({
  filter
}: IVariableTypeFreeDecimalProps) {
  const {
    findFieldIndexByGuidDynamicReportVariable,
    idScreen,
  } = useDynamicFiltersExport();
  const {
    control,
  } = useFormContext();

  const indexField = findFieldIndexByGuidDynamicReportVariable(filter.guidDynamicReportVariable);

  return (
    <>
      <KogInputTextControlledNew
        hasOnlyNumber
        numberOfDecimals={2}
        id={idScreen('txt-freeInteger')}
        name={`filtersDinamics.${indexField}.value`}
        label={filter.responseServer.filterName}
        required={filter.responseServer.mandatory}
        control={control}
      />
    </>
  )
}

export default VariableTypeFreeDecimal